import {
    useMemo,
    useCallback,
} from 'react'
import {
    Link,
} from 'react-router-dom'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'

import SkyNetTable from 'app/shared-components/SkyNetTable'
import Card from 'app/shared-components/Card'
import useContactManagementRoutes from 'app/SkyNetRoutes/hooks/useContactManagementRoutes'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'

import useStyles from '../CompanyOverview.styles'
import {
    Company,
} from '../../Companies.types'

import config from './BillingAddresses.config'

const DOMAIN_NAME = 'BillingCompany'

const BillingAddresses = ({
    data,
}: { data: Company }) => {
    const {
        BillingCompanies: BillingCompaniesRoutes,
    } = useContactManagementRoutes()
    const {
        classes,
    } = useStyles()

    const filter = useMemo(() => {
        return {
            companyId: [data?.id],
        }
    }, [data?.id])

    const onRowClick = useCallback(({
        id: billingCompanyId,
    }) => {
        BillingCompaniesRoutes.Update.navigate({
            params: {
                key: billingCompanyId,
            },
        })
    }, [BillingCompaniesRoutes])

    const createLocationLink = generateSkyNetLink({
        domainPath: BillingCompaniesRoutes.Create.path,
        searchParams: data?.id ? {
            companyId: String(data?.id),
        } : undefined,
    })

    return (
        <div
            className={classes.tableContainer}
        >
            <Card
                fullHeight
                className={classes.cardRoot}
                contentClass={classes.cardContent}
            >
                <div className={classes.header}>
                    <Typography
                        variant="h3"
                    >
                        Billing Addresses
                    </Typography>
                    <div className={classes.icon}>
                        <Link
                            className={classes.link}
                            to={createLocationLink}
                        >
                            <AddIcon
                                data-testid="open-create-locationType-BILLING_ADDRESS"
                                className={classes.icon}
                            />
                        </Link>
                    </div>
                </div>
                <SkyNetTable
                    name={DOMAIN_NAME}
                    simple
                    filter={filter}
                    tableConfig={config}
                    onRowClick={onRowClick}
                />
            </Card>
        </div>

    )
}

export default BillingAddresses
